@if (!isLoading()) {
<div class="close" (click)="close()">{{ 'NGX-MESSAGING.close' | translate }}</div>
<h1 mat-dialog-title class="mat-dialog-container__title">
  {{ 'NGX-MESSAGING.NEW-CHAT.createANewPhoneConversation' | translate | uppercase }}
</h1>
<div mat-dialog-content>
  <form [formGroup]="newChatForm">
    <mat-form-field appearance="fill" class="full-width-input">
      <input
        matInput
        placeholder="{{ 'NGX-MESSAGING.NEW-CHAT.customerFirstName' | translate }}"
        formControlName="firstName" />
    </mat-form-field>
    <mat-form-field appearance="fill" class="full-width-input">
      <input matInput placeholder="{{ 'NGX-MESSAGING.NEW-CHAT.customerLastName' | translate }}" formControlName="lastName" />
    </mat-form-field>
    <ngx-material-intl-tel-input
      [iconMakeCall]="false"
      [autoSelectCountry]="false"
      [required]="true"
      [fieldControl]="phoneControl"
      [autoIpLookup]="false"
      [preferredCountries]="['us']">
    </ngx-material-intl-tel-input>
    <mat-form-field appearance="fill" class="full-width-input mt-3">
      <mat-select placeholder="{{ 'NGX-MESSAGING.NEW-CHAT.channelType' | translate }}" formControlName="routing">
        @if (permissionsService.checkCanUseWhatsapp()) {
        <mat-option [value]="'WHATSAPP'">
          {{ 'WHATSAPP' | translate }}
        </mat-option>
        }
        <mat-option [value]="'SMS'">
          {{ 'SMS' | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button class="chat-input__button" color="primary" (click)="save()" [disabled]="!newChatForm.valid">
    {{ 'NGX-MESSAGING.NEW-CHAT.createConversation' | translate }}
  </button>
</div>
} @else {
<ngx-text-spinner [text]="'Starting conversation'"></ngx-text-spinner>
}
